import { Auth } from "aws-amplify";

export async function getIdToken() {
  const session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
}
